import React from 'react';
import styled from '@emotion/styled';
import { Title } from './components/Title';
import { Search } from './components/Search';
import { SearchContainer } from '../page-component/pageStyles';
import { Stack, SxProps } from '@mui/material';

export const PageContainer = styled.div`
  width: 100%;
  padding: 0 !important;
  margin-top: 10px;
`;

export const PageBodyContainer = styled.div`
  width: 100%;
  padding: 15px 24px !important;
`;

export const PageHeaderContainer = styled.div`
  width: 100%;
  background-color: #202633;
  display: flex;
  flex-direction: column;
  color: white;
`;

export function PageLayout({ children }: { children: React.ReactNode }) {
  return <PageContainer>{children}</PageContainer>;
}

export function PageBody({ children }: { children: React.ReactNode }) {
  return <PageBodyContainer>{children}</PageBodyContainer>;
}

export function PageHeader({ children }: { children: React.ReactNode }) {
  return <PageHeaderContainer>{children}</PageHeaderContainer>;
}

export function PageHeaderRow({
  children,
  sx,
  underline = false,
}: {
  children: React.ReactNode;
  sx?: SxProps;
  underline?: boolean;
}) {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          width: '100%',
          padding: '10px 24px',
          paddingTop: '20px',
          ...sx,
        }}
      >
        {children}
      </Stack>
      {underline && <HeaderDivider />}
    </>
  );
}

export function PageTitle({
  title,
  onSearch,
  placeHolderText,
  hideSearch,
  searchInitialValue,
}: {
  title: string;
  onSearch: ((value: string) => void) | null;
  placeHolderText: string;
  hideSearch?: boolean;
  searchInitialValue?: string;
}) {
  return (
    <SearchContainer>
      <Title title={title} />
      {!hideSearch && (
        <Search
          onSearch={onSearch}
          searchPlaceholder={placeHolderText}
          initialValue={searchInitialValue}
        />
      )}
    </SearchContainer>
  );
}

export function HeaderDivider() {
  return (
    <div
      style={{
        height: '10px',
        boxShadow: `0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 0px rgb(0 0 0 / 14%),
			0px 1px 0px rgb(0 0 0 / 12%)`,
      }}
    ></div>
  );
}

export function PageActionGroup({ children }: { children: React.ReactNode }) {
  return (
    <Stack direction="row" spacing={1}>
      {children}
    </Stack>
  );
}
